import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Footer from '../components/Footer';
import Menu from '../components/Menu';
import Header from '../components/Header';

import '../styles/global.scss';
import './styles/index.scss';

const IndexLayout = (props) => {
  const { children, data } = props;
  const { site, banner, defaultPreview } = data;
  
  return (
    <div>
      <Helmet
        title={site.siteMetadata.title}
        meta={[
          { name: 'description', content: 'Blog d\'un voyage à travers le Canada' },
        ]}
      />
      
      <Menu />

      <Header banner={banner.sizes} />
      
      <div className="indexClassName">
        { children({ ...props, defaultPreview }) }
      </div>

      <Footer />
    </div>
  );
};

IndexLayout.propTypes = {
  children: PropTypes.func,
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string,
      })
    }),
    banner: PropTypes.shape({
      sizes: PropTypes.object,
    }),
    defaultPreview: PropTypes.shape({
      sizes: PropTypes.object,
    }),
  })
};

export default IndexLayout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
    banner: imageSharp(id: { regex: "/header/banner.jpg/" }) {
      sizes(maxWidth: 1200, maxHeight: 300, cropFocus: SOUTH) {
        ...GatsbyImageSharpSizes
      }
    }
    defaultPreview: imageSharp(id: { regex: "/header/banner.jpg/" }) {
      sizes(maxWidth: 300, maxHeight: 200, cropFocus: SOUTH) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx